import React from 'react';

function ArrowSquareUp(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M22 4.25C22 3.00736 20.9926 2 19.75 2L4.25 2C3.00736 2 2 3.00736 2 4.25L2 19.75C2 20.9926 3.00736 22 4.25 22L19.75 22C20.9926 22 22 20.9926 22 19.75L22 4.25ZM16.4328 11.9421C16.1886 12.186 15.7929 12.1857 15.549 11.9415L12.6194 9.00778L12.6194 16.3906C12.6194 16.7357 12.3396 17.0156 11.9944 17.0156C11.6492 17.0156 11.3694 16.7357 11.3694 16.3906L11.3694 9.01134L8.43963 11.9417C8.19558 12.1858 7.79985 12.1859 7.55575 11.9418C7.31165 11.6978 7.3116 11.302 7.55566 11.0579L11.3779 7.23486C11.7198 6.89292 12.2742 6.89309 12.6158 7.23523L16.4335 11.0582C16.6774 11.3024 16.6771 11.6982 16.4328 11.9421Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowSquareUp;
